import { useEffect } from "react";

const SEO = ({ 
  title, 
  description, 
  keywords = "", 
  image = "https://indorinama.com/logo.png",
  url = "",
  type = "website",
  author = "Indorinama",
  canonicalUrl = "",
  noIndex = false,
  noFollow = false
}) => {
  useEffect(() => {
    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]');
    const prevKeywords = document.querySelector('meta[name="keywords"]');
    const prevOgTitle = document.querySelector('meta[property="og:title"]');
    const prevOgDesc = document.querySelector('meta[property="og:description"]');
    const prevOgImage = document.querySelector('meta[property="og:image"]');
    const prevOgUrl = document.querySelector('meta[property="og:url"]');
    const prevOgType = document.querySelector('meta[property="og:type"]');
    const prevCanonical = document.querySelector('link[rel="canonical"]');
    const prevRobots = document.querySelector('meta[name="robots"]');

    document.title = title ? `${title} | Indorinama` : "Indorinama - Advertising, Designing & Marketing Solutions";
    
    if (description) {
      let metaDesc = prevDesc;
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = description;
    }

    if (keywords) {
      let metaKeywords = prevKeywords;
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }

    if (image) {
      let ogImage = prevOgImage;
      if (!ogImage) {
        ogImage = document.createElement('meta');
        ogImage.setAttribute('property', 'og:image');
        document.head.appendChild(ogImage);
      }
      ogImage.content = image;
    }

    if (url || canonicalUrl) {
      const canonical = canonicalUrl || url;
      let ogUrl = prevOgUrl;
      if (!ogUrl) {
        ogUrl = document.createElement('meta');
        ogUrl.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrl);
      }
      ogUrl.content = canonical;

      let linkCanonical = prevCanonical;
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.rel = "canonical";
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.href = canonical;
    }

    let ogTitle = prevOgTitle;
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = title ? `${title} | Indorinama` : "Indorinama";

    let ogDesc = prevOgDesc;
    if (!ogDesc && description) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    if (description) ogDesc.content = description;

    let ogType = prevOgType;
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.content = type;

    let robots = prevRobots;
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    const robotsContent = [
      noIndex ? "noindex" : "index",
      noFollow ? "nofollow" : "follow"
    ].join(", ");
    robots.content = robotsContent;

    return () => {
      document.title = prevTitle || "Indorinama";
    };
  }, [title, description, keywords, image, url, type, canonicalUrl, noIndex, noFollow]);

  return null;
};

export default SEO;